module.exports = __webpack_public_path__ + "static/media/rom18.caf6224b.jpg";